<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import estadosBr from '@/constants/estados'
import { mapActions, mapGetters } from 'vuex'

export default {
  mixins: [onlyInputNumbers, AppNotificacao],
  components: {
    Label,
    TitleWithRow,
    InputSelect
  },
  props: {
    endereco: {
      required: true
    },
    nomeAba: {
      type: String,
      required: true
    },
    titulo: {
      type: String,
      required: false,
      default: 'Endereço de correspondência'
    },
    exibirTitulo: {
      type: Boolean,
      required: false,
      default: true
    },
    exibirSwitchMesmoEndereco: {
      default: false
    },
    enderecoCopiado: {
      required: false
    },
    camposObrigatorios: {
      type: Array,
      required: false,
      default: () => []
    },
    exibirBairroComplemento: {
      type: Boolean,
      required: false,
      default: true
    },
    tipoCadastro: {
      type: String
    }
  },
  data () {
    return {
      dadosIguaisCorrespondencia: false,
      estadosBrasileiros: [],
      municipiosBrasileiros: []
    }
  },
  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    mensagemSwitchMesmoEndereco () {
      switch (this.tipoCadastro) {
        case 'EMPRESA':
          return 'Os dados são os mesmos do endereço do cadastrante'
        case 'PARCEIROS_FORNECEDORES':
          return 'Os dados são os mesmos do endereço de correspondência do proprietário'
        default:
          return 'Os dados são os mesmos do endereço de correspondência do proprietário'
      }
    }
  },
  mounted () {
    this.estadosBrasileiros = estadosBr.map(estado => { return {id: estado.codigo, nome: estado.nome} })
    this.normalizarMunicipioDoEndereco()
    this.carregarMunicipios()
  },
  methods: {
    ...mapActions({
      enderecoByCep: 'endereco/findEnderecoByCep',
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),
    normalizarMunicipioDoEndereco () {
      if (!this.endereco) return
      if (this.endereco.municipio == null) {
        this.$set(this.endereco, 'municipio', { id: null, nome: null, codigoEstado: null })
      }
    },
    onSemNumeroCheck (checked) {
      if (checked) {
        this.endereco.numero = 0
        return
      }
      this.endereco.numero = null
    },
    async carregarMunicipios () {
      const codigoEstado = this.endereco?.municipio?.codigoEstado
      if (codigoEstado) {
        const municipios = await this.getMunicipiosByUf(codigoEstado)
        this.municipiosBrasileiros = municipios.map(({ id, nome }) => ({ id, nome }))
      }
    },
    async setaDadosEndereco (val) {
      const campos = [
        'cep', 'municipio', 'logradouro',
        'numero', 'semNumero', 'comunidadeLocalidade',
        'referencia', 'complemento'
      ]

      if (this.enderecoCopiado) {
        campos.forEach((campo) => {
          if (campo === 'municipio') {
            this.endereco[campo] = val ? this.enderecoCopiado[campo] : { id: null, nome: null, codigoEstado: null }
          } else {
            this.endereco[campo] = val ? this.enderecoCopiado[campo] : ''
          }
        })
      }
    },

    async buscarInfoByCep () {
      try {
        const data = await this.enderecoByCep(this.endereco.cep)

        if (data.erro) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            'CEP não encontrado!'
          )
          return
        }
        this.endereco.logradouro = data.logradouro
        this.endereco.bairro = data.bairro
        this.endereco.municipio = {
          id: Number(data.ibge),
          nome: data.localidade,
          codigoEstado: data.uf
        }
      } catch (error) {
        console.error('Erro ao buscar o CEP:', error)
      }
    },

    rulesByFields (campo) {
      const regras = []
      if (this.camposObrigatorios.includes(campo)) {
        regras.push('required')
        if (campo === 'CEP') {
          regras.push('cep')
        }
      }
      return regras.join('|')
    },

    isRequired (campo) {
      return this.camposObrigatorios.includes(campo)
    },
    async updateUF (sigla) {
      this.normalizarMunicipioDoEndereco()
      if (sigla) {
        const municipios = await this.getMunicipiosByUf(sigla)
        this.municipiosBrasileiros = municipios.map(municipio => { return {id: municipio.id, nome: municipio.nome} })
      }
      this.endereco.municipio.id = null
      this.endereco.municipio.nome = ''
    },
    async updateMunicipio (val) {
      if (val) {
        const municipio = this.municipiosBrasileiros.find(m => m.id === val)
        this.endereco.municipio = { id: municipio.id, nome: municipio.nome, codigoEstado: this.endereco.municipio?.codigoEstado }
      } else {
        this.endereco.municipio = { id: null, nome: null, codigoEstado: this.endereco.municipio?.codigoEstado }
      }
    }
  },
  watch: {
    'endereco.municipio': {
      immediate: true,
      handler () {
        this.normalizarMunicipioDoEndereco()
      }
    },
    async '$route' (to, from) {
      if (to.name === 'formulario-imovel') {
        this.dadosIguaisCorrespondencia = false
      }
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow :title="titulo" />
    <el-row v-if="exibirSwitchMesmoEndereco">
      <el-switch v-model="dadosIguaisCorrespondencia" @change="setaDadosEndereco" />
      <span>{{ mensagemSwitchMesmoEndereco }}</span>
    </el-row>
    <el-row :gutter="50">
      <el-col :span="6">
        <validation-provider :rules="rulesByFields('CEP')" v-slot="{ errors }" :name="nomeAba + '/CEP'">
          <Label label="CEP" :obrigatorio="isRequired('CEP')" />
          <el-input
            class="input"
            name="CEP"
            v-model="endereco.cep"
            v-mask="['#####-###']"
            placeholder="#####-###"
            :class="{ erro: errors.length }"
            clearable
            @change="buscarInfoByCep()"
          />
          <span class="help erro">{{ errors[0] }}</span>
        </validation-provider>
      </el-col>
      <InputSelect
        label="UF do imóvel"
        :obrigatorio="isRequired('UF')"
        :rulesInput="rulesByFields('UF')"
        :opcoes="estadosBrasileiros"
        :nomeAba="nomeAba"
        :widthColumn="6"
        v-model="endereco.municipio.codigoEstado"
        :value="endereco.municipio.codigoEstado"
        @input="updateUF"
      />
      <InputSelect
        label="Município do imóvel"
        :obrigatorio="isRequired('MUNICIPIO')"
        :rulesInput="rulesByFields('MUNICIPIO')"
        :opcoes="municipiosBrasileiros"
        :nomeAba="nomeAba"
        :widthColumn="6"
        v-model="endereco.municipio.nome"
        :value="endereco.municipio.nome"
        @input="updateMunicipio"
      />
    </el-row>

    <el-row>
      <el-col :span="13">
        <validation-provider :rules="rulesByFields('LOGRADOURO')" v-slot="{ errors }" :name="nomeAba + '/Logradouro'">
          <Label label="Logradouro" :obrigatorio="isRequired('LOGRADOURO')" />
          <el-input
            class="input"
            name="logradouro"
            placeholder="Digite o logradouro..."
            v-model="endereco.logradouro"
            maxlength="300"
            :class="{ erro: errors.length }"
          />
          <span class="help erro">{{ errors[0] }}</span>
        </validation-provider>
      </el-col>

      <el-col :span="6" class="ml-forms">
        <validation-provider :rules="rulesByFields('NUMERO')" v-slot="{ errors }" :name="nomeAba + '/Número'">
          <Label label="Número" :obrigatorio="isRequired('NUMERO')" />
          <el-input
            class="input"
            name="numero"
            v-model="endereco.numero"
            :disabled="endereco.semNumero"
            :onkeypress="onlyInputNumbers"
            maxlength="10"
            :showAppend="true"
            :class="{ erro: errors.length }"
            placeholder="Digite o número..."
          >
            <template #prepend>
              <el-checkbox
                class="input"
                v-model="endereco.semNumero"
                label="S/N"
                @change="onSemNumeroCheck"
              />
            </template>
          </el-input>
          <span class="help erro">{{ errors[0] }}</span>
        </validation-provider>
      </el-col>
    </el-row>

    <el-row v-if="exibirBairroComplemento">
      <el-col :span="13">
        <validation-provider :rules="rulesByFields('BAIRRO')" v-slot="{ errors }" :name="nomeAba + '/Bairro'">
          <Label label="Bairro" :obrigatorio="isRequired('BAIRRO')" />
          <el-input
            class="input"
            name="bairro"
            v-model="endereco.bairro"
            maxlength="100"
            :class="{ erro: errors.length }"
            placeholder="Digite o bairro..."
          />
          <span class="help erro">{{ errors[0] }}</span>
        </validation-provider>
      </el-col>
      <el-col :span="6" class="ml-forms">
        <validation-provider :rules="rulesByFields('COMPLEMENTO')" v-slot="{ errors }" :name="nomeAba + '/Bairro'">
          <Label label="Complemento" :obrigatorio="isRequired('COMPLEMENTO')"/>
          <el-input
            class="input"
            name="complemento"
            maxlength="100"
            v-model="endereco.complemento"
            :class="{ erro: errors.length }"
            placeholder="Digite o complemento..."
          />
          <span class="help erro">{{ errors[0] }}</span>
        </validation-provider>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss">
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/FormulariosProntos/Endereco/Endereco.vue